module.exports = __webpack_public_path__ + "static/media/warning-circle.7a3ef4ed.svg";